import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

export default {
    namespaced: true,
    state() {
        return {
            promoCodes: []
        }
    },
    getters: {
        promoCodes: (state) => {
            return state.promoCodes;
        }
    },
    mutations: {
        setPromoCodes(state, value) {
            state.promoCodes = value;
        },
        addPromoCode(state, item) {
            state.promoCodes.unshift(item);
        },
        updatePromoCode(state, item) {
            for (let i = 0; i < state.promoCodes.length; i++) {
                if (state.promoCodes[i].id === item.id) {
                    window.Vue.set(state.promoCodes, i, item);
                }
            }
        },
        removePromoCode(state, item) {
            for (let i = 0; i < state.promoCodes.length; i++) {
                if (state.promoCodes[i].id === item.id) {
                    window.Vue.delete(state.promoCodes, i, item);
                }
            }
        },
    }
};
